import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { style: {"padding":"20px"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "权限系统测试页面", -1)
const _hoisted_3 = { style: {"margin-bottom":"20px"} }
const _hoisted_4 = { style: {"margin-bottom":"20px"} }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", null, "测试1：使用存在的权限（如果你有 sysAds.list.update）", -1)
const _hoisted_6 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_7 = { style: {"margin-bottom":"20px"} }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", null, "测试2：使用不存在的权限", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"green"} }, " ✅ 如果看不到红色按钮，说明权限系统工作正常 ", -1)
const _hoisted_10 = { style: {"margin-bottom":"20px"} }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", null, "测试3：不使用权限指令（对照组）", -1)
const _hoisted_12 = { style: {"margin-bottom":"20px"} }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h3", null, "测试4：使用 v-if 判断权限", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "菜单数据：")
], -1)
const _hoisted_15 = { style: {"background":"#f5f5f5","padding":"10px","max-height":"300px","overflow":"auto"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_button = _resolveComponent("a-button")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_a_divider, null, {
      default: _withCtx(() => [
        _createTextVNode("当前权限列表")
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.permissionCodes.length === 0)
        ? (_openBlock(), _createBlock(_component_a_alert, {
            key: 0,
            message: "未获取到权限数据",
            type: "warning",
            "show-icon": ""
          }))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.permissionCodes, (code) => {
        return (_openBlock(), _createBlock(_component_a_tag, {
          key: code,
          color: "blue",
          style: {"margin":"5px"}
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(code), 1)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _createVNode(_component_a_divider, null, {
      default: _withCtx(() => [
        _createTextVNode("测试按钮")
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
        type: "primary",
        style: {"margin-right":"10px"}
      }, {
        default: _withCtx(() => [
          _createTextVNode(" ✅ 我有 sysAds.list.update 权限 ")
        ]),
        _: 1
      })), [
        [_directive_permission, 'sysAds.list.update']
      ]),
      (!_ctx.hasPermission('sysAds.list.update'))
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, " ❌ 你没有这个权限，所以按钮被隐藏了 "))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
        type: "danger",
        style: {"margin-right":"10px"}
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 这个按钮应该被隐藏（因为权限不存在） ")
        ]),
        _: 1
      })), [
        [_directive_permission, 'test.fake.permission']
      ]),
      _hoisted_9
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createVNode(_component_a_button, { type: "default" }, {
        default: _withCtx(() => [
          _createTextVNode(" 这个按钮没有权限控制，应该一直显示 ")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      (_ctx.hasPermission('sysAds.list.update'))
        ? (_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            type: "primary",
            style: {"margin-right":"10px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 使用 v-if 控制（有 sysAds.list.update 权限） ")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.hasPermission('sysAds.list.update'))
        ? (_openBlock(), _createBlock(_component_a_button, {
            key: 1,
            type: "default",
            disabled: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 你没有 sysAds.list.update 权限 ")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_a_divider, null, {
      default: _withCtx(() => [
        _createTextVNode("调试信息")
      ]),
      _: 1
    }),
    _createElementVNode("div", null, [
      _hoisted_14,
      _createElementVNode("pre", _hoisted_15, _toDisplayString(_ctx.menuListData), 1)
    ])
  ]))
}